@switch (layout()) {
  @case (Layout.Grid) {
    <lib-feature-tile-grid [reportPath]="reportPath()"/>
  }
  @case (Layout.List) {
    <lib-feature-tile-list [reportPath]="reportPath()"/>
  }
}
